<template>
  <div/>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {EnhancedWorkpace} from '@/types/Workspace'
import storage from '@/storage'
import {hasDimension, kanbanByDefault} from '@/utils/kanbanDimensions'

/**
 * A URL da coleção — `/workspaces/:system/collections/:idea` — não desenha nada: decide
 * qual das duas visões abrir e troca a rota por ela.
 *
 * A ordem da decisão é: a última visão usada nesta coleção; se nunca houve uma, o Kanban
 * quando a coleção tem FLUXO e a lista quando não tem.
 *
 * **Ter fluxo, e não ter dimensão.** O portão do Kanban foi alargado de propósito — hoje uma
 * coleção com um atributo de seleção e sem fluxo nenhum tem quadro —, e por um tempo o padrão
 * foi alargado junto. Eram duas perguntas: o que EXISTE e o que se ABRE sozinho. Uma coleção
 * passava a abrir em quadro por ter ganhado um campo de escolha, sem ninguém ter pedido, e a
 * listagem — a visão genérica, a que sempre serve — deixava de ser o ponto de partida dela.
 *
 * A aba do Kanban continua lá em qualquer coleção que tenha por onde agrupar: o que mudou é
 * de onde se parte, não o que se pode alcançar. Ver `kanbanByDefault` e `hasDimension`.
 *
 * **`replace` e não `push`**: entrar numa coleção tem de ser UM passo no histórico. Com
 * `push`, o botão "voltar" do navegador traria de volta esta URL, que mandaria adiante
 * de novo — e voltar viraria um laço.
 *
 * A guarda vale também para o que está gravado: uma coleção pode ter perdido a dimensão
 * depois de o Kanban ter sido usado nela — o fluxo desassociado, o atributo de seleção
 * apagado —, e a lembrança apontaria para uma tela que não existe mais.
 */
@Component({name: 'ontos-collection-entry'})
class CollectionEntry extends Vue {
  @Prop({required: true}) readonly workspace!: EnhancedWorkpace

  created() {
    const system = this.$route.params.system as string
    const ideaAlias = this.$route.params.idea as string
    const idea = this.workspace && this.workspace.ideaWith && this.workspace.ideaWith(ideaAlias)
    const hasKanban = !!idea && hasDimension(idea, this.workspace.ideas)

    const remembered = storage.collectionView(system, ideaAlias)
    //hasKanban guarda a LEMBRANÇA, e não o padrão: o quadro lembrado pode ter deixado de
    //existir. O padrão é a pergunta estreita, e como todo padrão é também disponível, não há
    //caso em que isto escolha o Kanban sem ele existir.
    const name = remembered && (hasKanban || remembered !== 'kanban')
        ? remembered
        : (!!idea && kanbanByDefault(idea) ? 'kanban' : 'list-instances')

    this.$router.replace({name, params: {system, idea: ideaAlias}})
  }
}

export default toNative(CollectionEntry)
</script>
